export default function DonneeFiltreesConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('donnee.filtrees');
}

DonneeFiltreesConfiguration.$inject = ['$translatePartialLoaderProvider'];
